import type { JSX, ParentComponent } from 'solid-js'
import { createMemo, mergeProps } from 'solid-js'
import { twMerge } from 'tailwind-merge'
import ButtonGroupContext from '~/contexts/ButtonGroupContext'
import type { ButtonGroupPropsType, ButtonPropsType } from '~/types/Button'

const ButtonGroup: ParentComponent<ButtonGroupPropsType> = (props): JSX.Element => {
  const merged = mergeProps(
    {
      variant: 'contained' as ButtonPropsType['variant'],
      color: 'primary' as ButtonPropsType['color'],
      size: 'md' as ButtonPropsType['size'],
      vertical: false,
      fullWidth: false
    },
    props as ButtonGroupPropsType
  )

  const groupClasses = createMemo(() => twMerge('button-group', merged.vertical ? 'vertical' : '', merged.fullWidth ? 'w-full' : '', merged.class || ''))

  const ctx = createMemo(() => ({ variant: merged.variant, color: merged.color, size: merged.size }))

  return (
    <ButtonGroupContext.Provider value={ctx()}>
      <div class={groupClasses()} classList={merged.classList}>
        {merged.children}
      </div>
    </ButtonGroupContext.Provider>
  )
}

export default ButtonGroup
